export default __webpack_public_path__ + "static/media/view-list.23dd95f8.svg";